import React, { Component } from 'react';

export default class OptGroup extends Component {
  static isSelectOptGroup = true;
}
